import React from 'react';
import { phoneTelHref } from '../utils/contactLinks';
import './ContactLink.css';

type PhoneLinkProps = {
  phone?: string | null;
  className?: string;
  fallback?: React.ReactNode;
};

const PhoneLink: React.FC<PhoneLinkProps> = ({ phone, className = '', fallback = '—' }) => {
  const display = String(phone ?? '').trim();
  if (!display) {
    return <>{fallback}</>;
  }
  const href = phoneTelHref(display);
  if (!href) {
    return <span className={className}>{display}</span>;
  }
  return (
    <a href={href} className={`contact-link contact-link--phone ${className}`.trim()}>
      {display}
    </a>
  );
};

export default PhoneLink;
